import { useQuery } from "@tanstack/react-query";
import { getTypeOfServices } from "../actions/getTypeOfService";

export const useTypeOfServiceQuery = ({ categoryType }: { categoryType?: string } = {}) => {
  return useQuery({
    queryKey: ["type-of-services", categoryType],
    queryFn: () => getTypeOfServices({ categoryType }),
  });
};
